import React from 'react'
import { Typography, Button } from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'

const ErrorCode = (props) => {
	const history = useHistory()
	const dispatch = useDispatch()
	const params = useParams()

	let { error } = props

	const goTo = (link) => {
		dispatch({ type: 'CLEAR_VISIT' })
		history.push(link)
	}

	return error && error.response ? (
		<div>
			<div
				style={{
					textAlign: 'center'
				}}>
				<Typography variant="h2" style={{ color: '#D02C2C', fontSize: '36px', marginBottom: '20px' }}>
					{error.response.status ? error.response.status : 'No status'}
				</Typography>
				<Typography variant="h3" style={{ color: '#1A1A35', fontSize: '16px', marginBottom: '20px' }}>
					{error.response.data && error.response.data.message
						? error.response.data.message
						: 'No message'}
				</Typography>
			</div>
			{error.stack ? (
				<pre
					style={{
						padding: 20,
						border: '1px solid #1A1A35',
						background: '#FFFFFF',
						marginBottom: 20
					}}>
					<code>{error.stack}</code>
				</pre>
			) : null}
			{params && params.facilityId && params.clientId ? (
				<div
					style={{
						textAlign: 'center'
					}}>
					<Button
						variant="contained"
						color="secondary"
						style={{
							marginRight: 10
						}}
						onClick={() => goTo(`/clients/${params.clientId}/appointments`)}>
						Go to client appointments
					</Button>
					<Button
						variant="outlined"
						color="secondary"
						onClick={() => goTo(`/facilities/${params.facilityId}/schedule`)}>
						Go to schedule
					</Button>
				</div>
			) : null}
		</div>
	) : null
}

export default ErrorCode
